import type { DirectiveBinding } from 'vue';

type Binding = DirectiveBinding<boolean, 'onupdate'>;

let UtilsLodash: typeof import('@/core/utils/lodash');

/**
 * Список элементов, на которых бала запрошена фокусировка, для дедупликации фокусировок
 */
let elsActive: HTMLElement[] = [];

/**
 * Функция скролла с дедупликацией
 */
let focusOnElActiveDebounce: Function;

/**
 * Выполнить фокусировку на активном элементе
 *
 * Если фокусирока запрошена на несколько элементов, будет выбран первый элемент
 */
const focusOnElActive = async () => {
	const { isVisible } = await import('@/core/utils/dom');
	elsActive = elsActive.filter(isVisible)

	if (!elsActive.length) return;

	const el = elsActive[0];

	el.focus();

	// // UX: Если выбрано несколько чекбоксов или радио после выбора фокусировка будет снята, чтобы не делать выбор за пользователя
	// if (elsActive.length && el.nodeName === 'INPUT') {
	// 	const type = (el as HTMLInputElement).type;
	// 	if (type === 'checkbox' || type === 'radio') el.blur();
	// }

	elsActive = [];
};

/**
 * Выполнить дедуплицированную фокусировку на элементе
 */
const focusOnElDebounce = async (el: HTMLElement) => {
	if (!UtilsLodash) UtilsLodash = await import('@/core/utils/lodash');
	if (!focusOnElActiveDebounce) focusOnElActiveDebounce = UtilsLodash.debounce(focusOnElActive, 30);

	elsActive.push(el);

	focusOnElActiveDebounce();
};

/**
 * Фокусировка на элементе сразу после его отображения
 */
const focus = {
	mounted: function (el: HTMLElement, binding: Binding) {
		el['__TOP_V_FOCUS_VALUE'] = binding.value ?? true;

		if (binding.value ?? true) focusOnElDebounce(el);
	},

	updated: function (el: HTMLElement, binding: Binding) {
		if (!binding.modifiers.onupdate) return;

		if (el['__TOP_V_FOCUS_VALUE'] === (binding.value ?? true)) return;
		el['__TOP_V_FOCUS_VALUE'] = binding.value ?? true;

		if (binding.value ?? true) focusOnElDebounce(el);
	},
};

export default focus;
